import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import Notificationdata from "./Notificationdata";
import Sidebar from "react-sidebar";
import SideBarComponent from "../../../common/components/notificationBar";
import Drawer from "rc-drawer";
import ReactDom from "react-dom";
import OutsideClickHandler from "react-outside-click-handler";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import Utils from "../../../utility";
import { notificationListService } from "../../../services/index";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
    fontSize: 16,
  },
  typography23: {
    padding: theme.spacing(2),
    fontSize: 14,
  },
  Avatar: {
    maxHeight: 25,
    maxWidth: 25,
  },
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    cursor: "pointer",
    right: "14px",
    top: "13px",
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

export default function SimplePopover(props) {
  const classes = useStyles();
  const [isOpen, setOpen] = React.useState(false);
  const [count, setCount] = React.useState([]);
  const userData = useSelector((state) => state?.user?.userDetails?.userDetails?.sub);

  React.useEffect(() => {
    countNotification();
  }, []);

  const countNotification = async () => {
    const reqObj = {
      queryObj: {
        userID: userData,
        isCleared: false,
        title:"Content Report"
      },
    };
    const [err, res] = await Utils.parseResponse(
      notificationListService.notificationCount(reqObj)
    );
    setCount(res?.count);
  };

  const handleClick = (e) => {
    e.preventDefault();
    setOpen(!isOpen)
    setCount("")
   }

  return (
    <div>
      <OutsideClickHandler
        onOutsideClick={() => {
          setOpen(false);
        }}
      >
        {count ? (
          <StyledBadge badgeContent={count} color="primary">
            <IconButton color="black">
              <img
                onClick={handleClick}
                className={classes.icon}
                src="/images/Icon awesome-bell.svg"
                alt=""
              />
            </IconButton>
          </StyledBadge>
        ) : (
          <IconButton color="black">
            <img
              onClick={handleClick}
              className={classes.icon}
              src="/images/Icon awesome-bell.svg"
              alt=""
            />
          </IconButton>
        )}
      </OutsideClickHandler>
      {isOpen && <SideBarComponent isOpen={isOpen} users={props?.user} />}

      {/* <Drawer
         open={true}
         defaultOpen={true}
         handler={<div>abc</div>}
      />
      , mountNode);
      , mountNode);
      <SideBarComponent onOpen={true}/>
      <span   className='side-bar'>
       <Sidebar

           sidebar={data.map((user) => (
               <div>{user.notificationData}</div>
           ))}

           open={true}
           onSetOpen={this.onSetSidebarOpen}
           styles={{ sidebar: { background: "white" } }}
       ></Sidebar></span> */}

      {/* <Popover
       id={id}
       open={open}
       anchorEl={anchorEl}
       onClose={handleClose}
       anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'center',
         height:351,
       }}
       transformOrigin={{
         
         vertical: 'top',
         horizontal: 'center',
       }}
      
      >
       <div className="up h-600 w-351" >
       <Typography className="notification p-19 fc-1f1f1f f-16" color="black">Notification</Typography>
       /!* <Typography className={classes.typography23}></Typography> *!/
       <Notificationdata/>
       </div>
      </Popover> */}
    </div>
  );
}
